export default "__VITE_ASSET__73cf74b4__"